import { newMailAction, newNoteAction } from '../strings.locstring.json';
import { newPostAction } from './NewMessageButton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import { isLeftRailVisible } from 'owa-left-rail-utils/lib/isLeftRailVisible';
import { getMailMenuItemShouldDisable, MenuItemType } from 'owa-mail-filterable-menu-behavior';
import { IButtonProps } from '@fluentui/react/lib/Button';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import { ControlIcons } from 'owa-control-icons';
import { IContextualMenuProps } from '@fluentui/react/lib/ContextualMenu';
import FluentCommandBarHeroButton from 'owa-fluent-commandbar/lib/FluentCommandBarHeroButton';
import { observer } from 'mobx-react-lite';
import { getPaletteAsRawColors } from 'owa-theme';

const styles = require('./NewMessageButton.scss');
const classNames = require('classnames/bind').bind(styles);

/**
 * For the sake of an easy visual example,
 * these dropdown buttons are being added without localization
 * or click handlers.
 *
 * TODO (OW:47860): localize + implement by scenario owner
 */
const fluentMenuProps: IContextualMenuProps = {
    items: [
        {
            key: 'newMessage',
            text: 'New message',
            iconProps: { iconName: ControlIcons.Edit },
        },
        {
            key: 'newCalendarEvent',
            text: 'New calendar event',
            iconProps: { iconName: ControlIcons.Calendar },
        },
        {
            key: 'newTask',
            text: 'New task',
            iconProps: { iconName: ControlIcons.CheckMark },
        },
    ],
};

export default observer(function NewMessageButton(
    props?: IButtonProps & {
        scenario: 'publicFolder' | 'notes' | 'default';
    }
) {
    const hasButtonWithIcon = isFeatureEnabled('mon-tri-newMessageButton');

    const newMessageButtonProps: IButtonProps = {
        text:
            props.scenario == 'publicFolder'
                ? loc(newPostAction)
                : props.scenario == 'notes'
                ? loc(newNoteAction)
                : loc(newMailAction),
        disabled: getMailMenuItemShouldDisable(MenuItemType.NewMessage),
        iconProps: hasButtonWithIcon
            ? {
                  iconName: ControlIcons.Edit,
                  styles: {
                      root: {
                          color: getPaletteAsRawColors().white + '!important',
                      },
                  },
              }
            : null,
    };

    return (
        <FluentCommandBarHeroButton
            className={classNames(
                isLeftRailVisible() && styles.newMessageButtonPadding,
                hasButtonWithIcon && styles.newMessageButtonWithIcon
            )}
            menuProps={isFeatureEnabled('fwk-fluentCommandBar-dropdowns') && fluentMenuProps}
            {...newMessageButtonProps}
            {...props}
        />
    );
});
